import React from "react";
import { Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { EmployeeApi } from "../../../../../../../../../../services/Api/Organization/types";

interface Props {
	employee: EmployeeApi;
}

const EmployeeTipsCard = ({ employee }: Props) => {
	const { t } = useTranslation();
	const history = useHistory();
	const organization = useSelector(selectOrganization);

	return (
		<Card>
			<Card.Body>
				<div className="d-flex align-items-center flex-wrap gap-2 mb-3">
					<h5 className="mb-0">{t("modules.employee.field.tips.title")}</h5>
					<span className={`badge ${employee.accept_tips ? "bg-success" : "bg-danger"}`}>
						{employee.accept_tips
							? t("modules.employee.field.tips_enabled.title")
							: t("modules.employee.field.tips_disabled.title")}
					</span>
				</div>
				{!employee.accept_tips && (
					<p className="mb-0 text-muted">{t("modules.employee.field.accept_tips.help_text")}</p>
				)}
				{employee.accept_tips && employee.bank_account_number && (
					<div className="card-body-item">
						<div className="item-info">
							<span className="label">{t("modules.employee.field.bank_account_number.title")}</span>
							<span>{employee.bank_account_number}</span>
						</div>
					</div>
				)}
				{employee.accept_tips ? (
					<Button
						className="mb-0"
						variant="add"
						onClick={() => history.push(`/${organization.id}/employees/${employee.id}/edit`)}
					>
						{t("lib:common.action.edit")}
					</Button>
				) : (
					<Button
						className="mt-3"
						onClick={() =>
							history.push(`/${organization.id}/employees/${employee.id}/edit`, { accept_tips: true })
						}
					>
						{t("modules.employee.action.turn_on.title")}
					</Button>
				)}
			</Card.Body>
		</Card>
	);
};

export default EmployeeTipsCard;
